

import React, { useState, useEffect } from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10">
        <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center">Política de Privacidad</h1>
        <div className="prose max-w-none text-gray-700 leading-relaxed">
          <p>En El Ancla CR estamos comprometidos con la protección de sus datos personales. Esta política explica qué información recopilamos, para qué la usamos, con quién la compartimos y qué derechos tiene usted sobre sus datos cuando interactúa con nuestra tienda en línea, redes sociales o canales de atención.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Información que recopilamos</h2>
          <p>Dependiendo del tipo de interacción, podemos recopilar:</p>
          <ul>
            <li><strong>Datos de identificación y contacto:</strong> nombre, apellidos, número de documento, correo electrónico, teléfonos y direcciones de envío/facturación.</li>
            <li><strong>Información de cuenta:</strong> credenciales de acceso, preferencias, historial de pedidos y tickets de soporte.</li>
            <li><strong>Datos de compra y pago:</strong> productos adquiridos, montos, métodos de pago (no almacenamos números completos de tarjetas) y comprobantes fiscales.</li>
            <li><strong>Datos logísticos:</strong> direcciones de entrega, referencias, historial de envíos y estados de pedidos.</li>
            <li><strong>Comunicaciones:</strong> mensajes enviados por WhatsApp, correo, formularios o redes sociales.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. ¿Para qué usamos sus datos?</h2>
          <p>Tratamos los datos personales para los siguientes fines:</p>
          <ul>
            <li>Procesar pedidos, cobros, devoluciones y solicitudes de garantía.</li>
            <li>Gestionar envíos, comunicaciones logísticas y atención postventa.</li>
            <li>Validar identidad, prevenir fraude y cumplir obligaciones legales.</li>
            <li>Enviar notificaciones transaccionales, promociones o contenidos relevantes (con opción de baja en cualquier momento).</li>
            <li>Analizar el uso del sitio para mejorar productos, contenidos y experiencia de usuario.</li>
            <li>Crear públicos personalizados y medir campañas en plataformas como Meta, Google o TikTok.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Compartición con terceros</h2>
          <p>Compartimos datos únicamente con proveedores que nos ayudan a operar el negocio, por ejemplo:</p>
          <ul>
            <li>Procesadores de pago, pasarelas y bancos para cerrar transacciones.</li>
            <li>Operadores logísticos y couriers para entregar pedidos.</li>
            <li>Servicios de email, mensajería y soporte para mantenerle informado.</li>
            <li>Herramientas de analítica, publicidad y redes sociales para medir y optimizar campañas.</li>
            <li>Autoridades o entidades regulatorias cuando la ley lo exija.</li>
          </ul>
          <p>Todos estos proveedores están obligados contractualmente a tratar los datos siguiendo nuestras instrucciones y la normativa aplicable.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Cookies y tecnologías similares</h2>
          <p>Utilizamos cookies propias y de terceros para recordar preferencias, mantener su sesión iniciada, medir tráfico y personalizar contenidos o anuncios. Usted puede gestionar estas cookies desde la configuración de su navegador o desactivar aquellas que no sean necesarias para el funcionamiento básico del sitio.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Conservación</h2>
          <p>Conservamos los datos mientras sean necesarios para cumplir con los fines descritos y las obligaciones legales (por ejemplo, registros contables o fiscales). Cuando ya no sean necesarios, los eliminamos o anonimizamos de manera segura.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Derechos del titular</h2>
          <p>Usted puede ejercer en cualquier momento los derechos de acceso, rectificación, oposición, portabilidad, limitación y supresión de sus datos personales. También puede solicitar la revocación de consentimientos otorgados o presentar reclamos ante la autoridad competente.</p>
          <p>Para ejercer sus derechos, escríbanos a <strong>info@elancla.store</strong> o al WhatsApp <strong>+506 8942 2525</strong>. Responderemos dentro de los plazos legales aplicables.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Cambios en esta política</h2>
          <p>Podemos actualizar esta política para reflejar cambios legislativos, operativos o tecnológicos. Le notificaremos los ajustes relevantes mediante el sitio web o los canales habituales. La fecha de la última actualización será siempre visible.</p>

          <p className="mt-8 text-sm text-gray-500">Última actualización: {new Date().toLocaleDateString('es-CR')}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
